import styled from "styled-components";

const ImageWrapper = styled.div`
  position: relative;
`;

const Image = styled.div`
  border-radius: 100%;
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0px 2px 5px rgba(206, 210, 227, 0.3);
  background-size: cover;
  background-position: center;
`;

const HiddenImage = styled.img`
  display: none;
`;

export { ImageWrapper, Image, HiddenImage };
